if (!customElements.get('diamond-ring-actions')) {
  window.DiamondRingsActions = class DiamondRingsActions extends DiamondActions {
    constructor() {
      super();
      this.handle = this.dataset.handle;
      this.submitBtn = this.querySelector('[data-action="select"]');
      window.journey_start_with = window.journey_start_with || 'setting';
      const tracker = document.querySelector('[data-journey-start-with]');
      if (tracker) {
        const startWith = tracker.dataset.journeyStartWith;
        if (startWith) window.journey_start_with = startWith;
      }

      if (this.submitBtn) this.submitBtn.addEventListener('click', this.submit.bind(this));

      try {
        Object.defineProperty(String.prototype, 'capitalize', {
          value: function () {
            return this.charAt(0).toUpperCase() + this.slice(1).toLowerCase();
          },
          enumerable: false,
        });
      } catch (e) { }
    }

    capitalize(str) {
      return (str.charAt(0)?.toUpperCase() || '') + (str.slice(1)?.toLowerCase() || '');
    }

    async submit() {
      const form = this.closest('.product-form');
      const idInput = form.querySelector('[name="id"]');
      const shapeInput = form.querySelector('[data-option-name="Shape"] input:checked');
      const metalInput = form.querySelector('[data-option-handle="metal"] input:checked');
      const variant_id = idInput ? idInput.value : null;
      const shape = (shapeInput ? shapeInput.value : 'round').replaceAll(' ', '_').toLowerCase().trim();
      const shapeCollectionUrl = window[`${shape}_collection_url`];
      const fingerSize = form.querySelector(`.cc-select__option[aria-selected="true"]`)?.dataset?.value;
      if (!variant_id) return;
      const attributes = {
        ring_handle: this.handle,
        ring_shape: shape.toUpperCase() || 'ROUND',
        ring_metal: this.capitalize(metalInput?.value || ''),
        ring_variant_id: variant_id,
        ring_Finger_size: fingerSize,
        ring_timestamp: Date.now(),
      };

      if (window.journey_start_with === 'setting') {
        attributes.rings_collection_url = window.rings_collection_url;
      }

      try {
        DiamondActions.showOverlay({ msg: `Preparing Your ring ...` });
        await DiamondActions.updateCartAttrs({ attributes });
        //debugger;
        if (window.journey_start_with === 'diamond') return (window.location.href = window.complete_engagement_ring_url);
        const url = this.dataset.diamond === 'natural' ? window.natural_search_page_url : window.lapgrown_search_page_url;
        window.location.href = url + `?journey_start_with=setting`;
      } catch (error) {
        console.error('error', error);
        alert(error.message);
      }
    }
  };

  window.customElements.define('diamond-ring-actions', DiamondRingsActions);
}
